import { email } from 'react-admin';

export const roleChoices = [
    { id: 'user', name: 'User' },
    { id: 'admin', name: 'Admin' },
]

export const checkPassword = (value) => {
    if (value.length < 8) {
        return { pass: false, error: 'Password must be at least 8 characters.' };
    }
    if (!value.match(/\d/) || !value.match(/[a-zA-Z]/)) {
        return { pass: false, error: 'Password must contain at least 1 letter and 1 number.' };
    }
    return { pass: true };
};

export const validateForm = passwordRequired =>
    values => {
        const errors = {};
        if (!values.name) {
            errors.name = 'ra.validation.required';
        }
        if (!values.role) {
            errors.role = 'ra.validation.required';
        }
        if (!values.email) {
            errors.email = 'ra.validation.required';
        } else {
            const error = email()(values.email);
            if (error) {
                errors.email = error;
            }
        }
        if (!values.password) {
            if (passwordRequired) {
                errors.password = 'ra.validation.required';
            }
        } else {
            if (values.password !== values.confirm_password) {
                errors.password = 'Passwords are different.';
            } else {
                const { pass, error } = checkPassword(values.password)
                if (!pass) {
                    errors.password = error;
                }
            }
        }
        return errors;
    };

const acceptKeys = ['email', 'password', 'name', 'role'];

export const transformRecord = (data) => {
    const sanitizedData = {};
    for (const key in data) {
        if (acceptKeys.includes(key) && data[key]) {
            sanitizedData[key] = data[key];
        }
    }
    return sanitizedData;
};
